import Vue from 'vue'
import ToastPlugin from 'vue-toast-notification'
import Router from 'vue-router'
import { routes } from '@/router/routes'
import store from '@/store'
import head from 'lodash-es/head'
import * as types from '@/store/mutation-types'

Vue.use(Router)
Vue.use(ToastPlugin)

const toggleRouteLoader = (show) => {
	const loader = document.getElementById('loading')
	if (!loader) {
		return
	}
	loader.style.display = show ? 'flex' : 'none'
}

const router = new Router({
	mode: 'history',
	/* base: '/cms2/', */
	routes
})

const parseRouteAllowlist = () => {
	if (!process.env.ROUTE_ALLOWLIST) {
		return []
	}
	try {
		const parsed = JSON.parse(process.env.ROUTE_ALLOWLIST)
		return Array.isArray(parsed) ? parsed : []
	} catch (error) {
		return []
	}
}

const isRouteAllowedForClient = (routeName) => {
	const allowlist = parseRouteAllowlist()
	if (!allowlist.length || !routeName) {
		return true
	}

	return allowlist.some((allowedName) => {
		if (routeName === allowedName) {
			return true
		}
		return routeName.startsWith(`${allowedName}.`)
	})
}

/**
 * Global Before Guards
 *
 * @param to
 * @param from
 * @param next
 * @returns {Promise<void>}
 */
const beforeEach = async (to, from, next) => {
	// Check if this feature is block from current client env
	if (to.meta && to.meta.denied && to.meta.denied.includes(process.env.CLIENT_ENV)) {
		Vue.$toast.open({
			message: 'Hiện tại chức năng này chưa được mở ở phiên bản hiện tại, vui lòng liên hệ đội ngũ kỹ thuật',
			type: 'error',
			position: 'top-right',
			duration: 3000
		})
		return false
	}
	if (!isRouteAllowedForClient(to.name)) {
		Vue.$toast.open({
			message: 'Phiên bản hiện tại chỉ mở một nhóm chức năng giới hạn cho doanh nghiệp này.',
			type: 'warning',
			position: 'top-right',
			duration: 3000
		})
		return next({ name: 'workflows.user_task' })
	}
	const currentRoute = head(to.matched)
	store.commit(types.SET_LAYOUT, { layout: currentRoute.meta.layout })
	toggleRouteLoader(true)
	next()
}

/**
 * Global After Hooks
 *
 * @returns {Promise<void>}
 */
const afterEach = async () => {
	if (router.app && typeof router.app.$nextTick === 'function') {
		await router.app.$nextTick()
	} else {
		await Vue.nextTick()
	}
	store.commit(types.END_LOADING)
	toggleRouteLoader(false)
}
router.beforeEach(beforeEach)
router.afterEach(afterEach)
router.onError(() => {
	store.commit(types.END_LOADING)
	toggleRouteLoader(false)
})
export default router
